
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("5KGDH", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $7e30b5c62155966e$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Danish (Denmark)
var $7e30b5c62155966e$export$2e2bcd8739ae039 = {
    'extension.charts.aggregateData': 'Aggreger data',
    'extension.charts.aggregateDataDescription': "Kombiner v\xe6rdier i et enkelt datapunkt, n\xe5r flere r\xe6kker har den samme v\xe6rdi.",
    'extension.charts.category': 'Kategori',
    'extension.charts.customizeTab': 'Tilpas',
    'extension.charts.dataMissing.details': "Vi kan ikke finde dette diagrams kildetabel p\xe5 siden.",
    'extension.charts.dataMissing.title': 'Der er ingen data til visning',
    'extension.charts.dataTab': 'Data',
    'extension.charts.defaultColumnName': 'Kolonne {0}',
    'extension.charts.defaultTitle': 'Diagram uden titel',
    'extension.charts.defaultYLabel': 'Akse uden titel',
    'extension.charts.extensionTitle': 'Diagram',
    'extension.charts.height': "Diagramh\xf8jde",
    'extension.charts.height.large': "H\xf8jere",
    'extension.charts.height.medium': 'Standard',
    'extension.charts.height.small': 'Lavere',
    'extension.charts.horizontal.orientation.label': 'Vandret',
    'extension.charts.insert.tooltip': "Inds\xe6t diagram",
    'extension.charts.legend': 'Tegnforklaring',
    'extension.charts.legend.auto': 'Automatisk',
    'extension.charts.legend.bottom': 'Forneden',
    'extension.charts.legend.left': 'Til venstre',
    'extension.charts.legend.position': 'Placering af tegnforklaring',
    'extension.charts.legend.right': "Til h\xf8jre",
    'extension.charts.legend.show': 'Vis tegnforklaring',
    'extension.charts.legend.top': 'Foroven',
    'extension.charts.options.label': 'Indstillinger for diagram',
    'extension.charts.options.tooltip': 'Skift indstillinger for diagram',
    'extension.charts.orientation.label': 'Orientering',
    'extension.charts.seriesNames': 'Dataserier',
    'extension.charts.showPoints': 'Vis datapunkter',
    'extension.charts.smoothLines': 'Glatte linjer',
    'extension.charts.style': 'Stil',
    'extension.charts.title': 'Titel',
    'extension.charts.type.bar': "S\xf8jle",
    'extension.charts.type.fieldDescription': 'Diagramtype',
    'extension.charts.type.line': 'Linje',
    'extension.charts.type.pie': 'Lagkage',
    'extension.charts.userTitle': 'Titel',
    'extension.charts.vertical.orientation.label': 'Lodret',
    'extension.charts.xAxis': 'X-akse',
    'extension.charts.xLabel': 'Etiket for X-akse',
    'extension.charts.yLabel': 'Etiket for Y-akse'
};

});


//# sourceMappingURL=da.7017fa9f.js.map
